import {
    CLEAR_KMS_SEARCH_ERROR,
    CLEAR_KMS_SEARCH_RESULTS,
    SEARCH_KMS_FAIL,
    SEARCH_KMS_SUCCESS,
    SET_KMS_SEARCH_LOADING,
} from "../actions/kmsSearchActions";

const initialState = {
    loading: false,
    error: null,
    keyword: "",
    page: 0,
    size: 20,
    totalResults: 0,
    totalContents: 0,
    totalDocuments: 0,
    hasNext: false,
    items: [],
};

export default function kmsSearchReducer(state = initialState, action) {
    switch (action.type) {
        case SET_KMS_SEARCH_LOADING:
            return { ...state, loading: action.payload };

        case SEARCH_KMS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                keyword: action.payload?.keyword || "",
                page: action.payload?.page || 0,
                size: action.payload?.size || 20,
                totalResults: action.payload?.totalResults || 0,
                totalContents: action.payload?.totalContents || 0,
                totalDocuments: action.payload?.totalDocuments || 0,
                hasNext: Boolean(action.payload?.hasNext),
                items: action.payload?.items || [],
            };

        case SEARCH_KMS_FAIL:
            return { ...state, loading: false, error: action.error };

        case CLEAR_KMS_SEARCH_ERROR:
            return { ...state, error: null };

        case CLEAR_KMS_SEARCH_RESULTS:
            return { ...initialState };

        default:
            return state;
    }
}
